import { useEffect, useRef, useState } from 'react'
import HttpAPICall from '../../../../services/HttpAPICall';
import { APP_BASE_URL_2 } from '../../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import Loader from '../../../../components/ui/Loader/Loader';
import TapIcon from '../../../../services/TapIcon';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import TapSelect from '../../../../components/ui/TapSelect';

function ExpenseHead() {

    const modalId           =   uuid();
    const modalElementRef   =   useRef();
    const modalRef          =   useRef();
    const expenseUrl        =   APP_BASE_URL_2 + '/logistic/expense_head';
    const accessToken       =   useSelector(state => state.auth.access_token);
    
    const initialData       =   {
        name                    :   '',
        head_type               :   '',
    };
    const logisticType      =   [
        {label: 'Domestic', value: 'domestic'},
        {label: 'International', value: 'international'},
        {label: 'Domestic & International', value: 'dom_inter'}
    ];

    const [listData, setListData]   =   useState({
        loading     :   false,
        data        :   []
    });
    const [formData, setFormData]   =   useState({
        submittingForm  :   false,
        submitData      :   initialData,
        editId          :   null,
    });

    useEffect(() => {
        listDataApi();
        modalElementRef.current         =   document.getElementById(modalId);
        modalRef.current                =   new Modal(modalElementRef.current, {keyboard: false, backdrop :false});

        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);

    const openModal                 =   () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal                =   () => {
        setFormData(pre => ({...pre, editId: null, submitData: initialData}))
        if (modalRef.current) {
            modalRef.current.hide();
        }
    }

    const listDataApi       =   ()  => {

        setListData(pre => ({...pre, loading : true}));

        HttpAPICall.withAthorization('GET', `${expenseUrl}/list`, accessToken, {}, {}, (resp) => {
            setListData(pr => ({...pr, data : resp.data.data}));            
        }).then(() => setListData(pr => ({...pr, loading : false})));

    }

    const submitForm                =   (e) => {
        e.preventDefault();

        setFormData(pre => ({...pre, submittingForm: true}));
        let method      =   'POST';
        let url         =   `${expenseUrl}/add`;
        let params      =   {
            ...formData.submitData,
            key: formData.submitData.name === 'Freight Forwarding Cost' 
            ?   'logistic_cost' 
            :   formData.submitData.name === 'Transporter Cost' 
            ?   'handling_cost' 
            :   createSlug(formData.submitData.name)
        };
        if(formData.editId) {
            method          =   "PUT";
            url             =   `${expenseUrl}/edit`;
            params          =   {...params, id : formData.editId}
        }
        HttpAPICall.withAthorization(method, url, accessToken, {}, params, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            closeModal();
            listDataApi();
        }).then(() => setFormData(pre => ({...pre, submittingForm: false})));

    }

    const handleEdit                =   (data) => {
        setFormData(pre => ({...pre, editId: data.id, submitData: {name: data.name, head_type: data.head_type}}));
        openModal();
    } 

    function createSlug(text) {
        return text
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '') // Remove special characters
            .replace(/[\s_-]+/g, '_') // Replace spaces and hyphens with underscores
            .replace(/^-+|-+$/g, ''); // Remove leading/trailing underscores
    }



    const modalJsx                  =   () => {
    
        const {submittingForm}      =   formData;

        return <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{formData.editId ? 'Edit' : 'Add'} Expense Head</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" disabled={submittingForm} onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={submitForm} id={modalId+"Form"} method="post">
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label className="form-label require">Name</label>
                                </div>
                                <div className="col-sm-6">
                                    <input
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        onChange={(e) => {
                                            setFormData(pre => ({...pre, submitData: {...formData.submitData, name: e.target.value}}))
                                        }}
                                        value={formData.submitData.name}
                                        autoComplete="off"
                                        required={true}
                                        placeholder={`Please enter name`}
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3 z-index-3">
                                <div className="col-sm-3">
                                    <label className="form-label require">Type</label>
                                </div>
                                <div className="col-sm-6">
                                    <TapSelect
                                        changeEvent={(selectedOption) => {
                                            setFormData(pre => ({...pre, submitData : {
                                                ...formData.submitData, 
                                                head_type : selectedOption ? selectedOption.value : '' 
                                            }}))
                                        }}
                                        options={logisticType}
                                        isSearchable={true}
                                        isClearable={true}
                                        required={true}
                                        value={logisticType.find(s => s.value == formData.submitData.head_type)}
                                        placeholder="Select Type"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" disabled={submittingForm} data-bs-dismiss="modal" onClick={closeModal}>Close</button>
                        <button type="submit" form={modalId+"Form"} disabled={submittingForm} className="btn btn-primary">Save {submittingForm && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                    </div>
                </div>
            </div>
        </div>
    }


  return (
    <div className="tab_content_header">
        <div className="tab_content_wrapper mt-2">
            <span className="content_heading">Expense Head</span>
            <div className="text-end "><button className="btn btn-primary" onClick={openModal}>Add</button></div>
        </div>
        <table className="table table-hover table-bordered my-4 table-sm ">
            <thead className="table-secondary">
                <tr className="text-center">
                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col" style={{ width: "15%" }}>Action</th>
                </tr>
            </thead>
            <tbody>
            {
                listData.loading 
                ? <tr><td colSpan={4}><Loader/></td></tr>
                :
                listData.data.length > 0 
                ?
                listData.data.map((d, i) => (
                    <tr className="text-center">
                        <td>{i+1}</td>
                        <td>{d.name}</td>
                        <td>{logisticType.find(t => t.value === d.head_type)?.label }</td>
                        <td>
                            <span className="dropdown">
                            <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn">
                                <TapIcon.FontAwesomeIcon icon={TapIcon.faEllipsisV} />
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li><Link className="dropdown-item" role="button" onClick={() => handleEdit(d)}>Edit</Link></li>
                            </ul>
                        </span>
                        </td>
                    </tr>
                ))
                :
                <tr className='text-center'><td colSpan={4}>No Record Found</td></tr>
            }
            </tbody>
        </table>
        {/* <DisplayListPagination meta={this.state.listingMeta} onPageChange={(e) => this.getCNFAgentConfigurationListing(e.selected + 1)} /> */}
        {modalJsx()}
    </div>
  )
}

export default ExpenseHead